import { useSelector } from 'react-redux'

export const useGetAuthenticatedUser = () =>
  useSelector((store: $TSFixMe) => {
    return store.settings.user
  })
